import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import {
  gtmEventPush,
  gtmPromotionImpressions,
  gtmPromotionClick,
  gtmListingProductImpressions,
  gtmPlpBannerClick,
  gtmPlpBannerView
} from '../../../modules/ga/GTMdatalayer';
import { FLEEK_STORE } from '../../../constants/constant';
import UTILS from '../../../utils/jioAdsUtils';
import { readCookie } from '../Cookie';
import { getPlaAdsClientID } from '../../../refresh/selectors/featureFlagsSelector';
import endpoints from '../../../modules/ajio-util/endpoints';
import { signInCheck } from '../CheckUserStatus';
import { sha256Hex } from '../../../utils/products';
import { isMobile } from '../../../refresh/utils/deviceTypeUtils';

function isInViewport(el) {
  if (!el) return false;
  const rect = el.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

// this is for the back button functionality - for banner GA event
// we have to keep track which banner are seens and not fire the event for those events
function setBannerAdsViewedInSession(ids) {
  let adsViewed = sessionStorage.getItem('bannerAdsViewed');

  if (adsViewed) {
    adsViewed = JSON.parse(adsViewed);
  } else {
    adsViewed = {};
  }

  if (typeof ids === 'string') {
    adsViewed[ids] = true;
  } else {
    ids.forEach(id => {
      adsViewed[id] = true;
    });
  }

  sessionStorage.setItem('bannerAdsViewed', JSON.stringify(adsViewed));
}
// getting if the banner ads already viewed for back button functionality
function getBannerAdsViewedInSession(id) {
  let adsViewed = sessionStorage.getItem('bannerAdsViewed');
  if (adsViewed === null) return false;
  adsViewed = JSON.parse(adsViewed);
  return adsViewed[id] === true;
}

function setOsmosBannerViewedInSession(uclid) {
  if (!uclid) return;
  let adsViewed = sessionStorage.getItem('osmosBannerAdsViewed');
  if (adsViewed) {
    adsViewed = JSON.parse(adsViewed);
  } else {
    adsViewed = {};
  }
  adsViewed[uclid] = true;
  sessionStorage.setItem('osmosBannerAdsViewed', JSON.stringify(adsViewed));
}

function getOsmosBannerViewedInSession(uclid) {
  if (!uclid) return false;
  let adsViewed = sessionStorage.getItem('osmosBannerAdsViewed');
  if (adsViewed === null) return false;
  adsViewed = JSON.parse(adsViewed);
  return adsViewed[uclid] === true;
}

export const bannerAdViewType = {
  desktop: '1440x178',
  grid: '512x910',
  list: '1024x320'
};
const productImpData = [];

export function JioAds({
  listingAds,
  data,
  adPos,
  style,
  dimension,
  freeTextSearch,
  gaAddPosition,
  inViewPort,
  showAdTag,
  currentStore = '',
  isPlpBannerOsmosEnabled=false
}) {
  const bannerImageElRef = useRef();
  const impressionFiredRef = useRef(false); // Track if impression was already fired for this component instance

  const fireOsmosBannerImpression = (adSource, uclid, client_id, cli_ubid, adData) => {
  if (adSource !== "osmos" && adSource !== "OSMOS") {
    return;
  }

  if (!data.imptrackers || !data.imptrackers[0]) {
    return;
  }

  if (uclid && getOsmosBannerViewedInSession(uclid)) {
    console.log('OSMOS banner impression already fired for uclid:', uclid);
    return;
  }

  if (impressionFiredRef.current) {
    console.log('OSMOS banner impression already fired for this component instance');
    return;
  }

  if (uclid) {
    setOsmosBannerViewedInSession(uclid);
  }
  impressionFiredRef.current = true;

  try {
    const impressionTrackerUrl = new URL(data.imptrackers[0]);
    
    const event_time = Date.now();
    
    const paramsToAdd = {
      client_id: client_id || getPlaAdsClientID(window?.__PRELOADED_STATE__) || '',
      uclid: uclid || '',
      cli_ubid: cli_ubid || '',
      position: gaAddPosition || adPos - 1,
      os_version: "",
      os_name: isMobile() ? "m_web" : "Desktop",
      event_time
    };
    
    Object.entries(paramsToAdd).forEach(([key, value]) => {
      if (value !== undefined && value !== "") {
        impressionTrackerUrl.searchParams.set(key, value);
      }
    });
    
    
    fetch(impressionTrackerUrl.toString(), {
      method: 'POST',
    })
      .then(() => {
        console.log(
          'OSMOS banner impression tracker fired successfully 🚀',
        );
      })
      .catch(err => {
        console.error('OSMOS banner impression tracker failed', err);
        impressionFiredRef.current = false;
        if (uclid) {
          let adsViewed = sessionStorage.getItem('osmosBannerAdsViewed');
          if (adsViewed) {
            adsViewed = JSON.parse(adsViewed);
            delete adsViewed[uclid];
            sessionStorage.setItem('osmosBannerAdsViewed', JSON.stringify(adsViewed));
          }
        }
      });
  } catch (error) {
    console.error('OSMOS: Invalid impression tracker URL', error, data.imptrackers[0]);
    impressionFiredRef.current = false;
  }
};

  const fireLoadImpression = (campaignId, bannerName, creative, creative_slot, adPos) => {
    if(isPlpBannerOsmosEnabled) return;

    console.log('Load impression fired for adPos ->', adPos);
    const ccbKey = campaignId.toString() + bannerName.toString();
    const ccb = UTILS.getCCB(ccbKey);

    const adsData = {
      id: campaignId,
      name: `jioads - ${bannerName}`,
      creative: dimension,
      position: gaAddPosition
    };

    const adsDataClickImp = {
      id: campaignId,
      name: `jioads - ${bannerName}`,
      creative: dimension,
      position: gaAddPosition
    };
    productImpData.push(adsDataClickImp);
    localStorage.setItem('plpPageTitle', freeTextSearch);
    localStorage.setItem('jioadsData', JSON.stringify(adsData));
    localStorage.setItem('plp_page_title', freeTextSearch);
    // gtmListingProductImpressions(productImpData, true);
    const imptracker = data.imptrackers[0]
      .replaceAll('[trq]', Date.now())
      .replaceAll('[ccb]', ccb);
    fetch(imptracker).catch(err => {
      console.log('JIO ads fire impression failed');
    });
  };

 useEffect(() => {
    impressionFiredRef.current = false;

    if(!isPlpBannerOsmosEnabled) {

    // if the banner ad component load for the first time and banner ads is in the viewport
    if (isInViewport(bannerImageElRef.current)) {
      console.log('Banner visible in view port initially - ', adPos);

      let currAd = listingAds[adPos - 1];

      if (getBannerAdsViewedInSession(currAd.cmpid)) {
        console.log('Current ads already visible doing nothing -> ', adPos, currAd);
        return;
      }

      const adData = {
        id: currAd.cmpid,
        name: `jioads - ${currAd?.title}`,
        creative: dimension,
        position: adPos - 1
      };

      inViewPort.push(adData);

      fireLoadImpression(currAd?.cmpid, currAd?.title, currAd?.desc, currAd?.sltId, adPos);

      setBannerAdsViewedInSession(currAd.cmpid);

      console.log('ads data in viewport: ', inViewPort);
    } else {
      // add a scroll listener and fire when the ads in viewport
      document.addEventListener('scroll', scrollListener2);
    }

    function scrollListener2() {
      if (isInViewport(bannerImageElRef.current)) {
        document.removeEventListener('scroll', scrollListener2);

        let currAd = listingAds[adPos - 1];

        if (getBannerAdsViewedInSession(currAd.cmpid)) {
          console.log('Current ads already visible doing nothing -> ', adPos, currAd);
          return;
        }
        const adData = {
          id: currAd.cmpid,
          name: `jioads - ${currAd?.title}`,
          creative: dimension,
          position: adPos - 1
        };

        inViewPort.push(adData);

        fireLoadImpression(currAd?.cmpid, currAd?.title, currAd?.desc, currAd?.sltId, adPos);

        if (inViewPort.length === 5) {
          console.log('Five ads inViewport firing auto event', inViewPort);
          gtmPromotionImpressions(inViewPort);
          // inViewPort = []; this will not work as inViewPort is a new variable
          // and we want to update the refrence
          inViewPort.length = 0;
        }

        setBannerAdsViewedInSession(currAd.cmpid);

        console.log('ads data in viewport: ', inViewPort);
      }
    }
       return () => {
      document.removeEventListener('scroll', scrollListener2);
    };
  } else {
    // New code for when isPlpBannerOsmosEnabled is true
    // Always use scroll listener to fire impression only when banner enters viewport
    function scrollListener3() {
      if (isInViewport(bannerImageElRef.current)) {
        document.removeEventListener('scroll', scrollListener3);

        const currentAd = listingAds[adPos - 1];
        const uclid = data?.uclid || currentAd?.uclid || '';

        const isOsmosAd = (data?.adSource || currentAd?.adSource || '').toUpperCase() === 'OSMOS';
        const shouldSkip = isOsmosAd
          ? getOsmosBannerViewedInSession(uclid) || impressionFiredRef.current
          : getBannerAdsViewedInSession(currentAd?.cmpid);

        if (shouldSkip) {
          return;
        }

        const adData = {
          id: currentAd.cmpid,
          name: `${currentAd?.adSource === 'OSMOS' ? `osmos - ${currentAd?.title}` : `jioads - ${currentAd?.title}`}`,
          creative: dimension,
          position: adPos - 1,
          uclid: uclid,
          client_id: data?.cid || currentAd?.cid || getPlaAdsClientID(window?.__PRELOADED_STATE__) || '',
          ad_source: data?.adSource || currentAd?.adSource || ''
        };

        inViewPort.push(adData);
        const cli_ubid_scroll = signInCheck() ? sha256Hex(readCookie('CI')) || '' : sha256Hex(readCookie('segment_device_id')) || '';
        fireOsmosBannerImpression(adData.ad_source, adData.uclid, adData.client_id, cli_ubid_scroll, adData);

        if (inViewPort.length === 5) {
          console.log('Five ads inViewport firing auto event', inViewPort);
          gtmPlpBannerView(inViewPort);
          inViewPort.length = 0;
        }

        if (!isOsmosAd && currentAd?.cmpid) {
          setBannerAdsViewedInSession(currentAd.cmpid);
        }

        console.log('ads data in viewport: ', inViewPort);
      }
    }

    document.addEventListener('scroll', scrollListener3);

    return () => {
      document.removeEventListener('scroll', scrollListener3);
    };
  }
  }, [adPos]);

  const fireClickImpression = (campaignId="", bannerName="", creative, creative_slot) => {
    if(isPlpBannerOsmosEnabled) {
      const uclid = data?.uclid || listingAds[adPos - 1]?.uclid || '';
      const banner_name_title = bannerName || listingAds[adPos - 1]?.title;
      const client_id = data?.cid || listingAds[adPos - 1]?.cid || getPlaAdsClientID(window?.__PRELOADED_STATE__) || '';
      const ad_source = data?.adSource || listingAds[adPos - 1]?.adSource || '';
      const scl_id = data?.scl_id || listingAds[adPos - 1]?.sclid || '';
      const promo_name = ad_source === "OSMOS" ? `osmos - ${banner_name_title}` : `jioads - ${banner_name_title}`;
      gtmPlpBannerClick(campaignId, promo_name, dimension, adPos - 1,true, uclid, client_id, ad_source, scl_id) ;

      if (ad_source === "OSMOS") {
        const cli_ubid = signInCheck() ? sha256Hex(readCookie('CI')) || '' : sha256Hex(readCookie('segment_device_id')) || '';
        const event_time = Date.now();
        // const clickTrackerUrl = new URL(data.clktrackers[0]);
        const clickTrackerUrl = new URL(endpoints.get('osmosClickTracker'));
        const paramsToAdd = {
          client_id,
          cli_ubid,
          uclid,
          event_time: event_time.toString()
        };
        // Object.entries(paramsToAdd).forEach(([key, value]) => {
        //   if (!clickTrackerUrl.searchParams.has(key) && value !== undefined && value !== '') {
        //     clickTrackerUrl.searchParams.set(key, value);
        //   }
        // });
        Object.entries(paramsToAdd).forEach(([key, value]) => {
          if (value !== undefined && value !== '') {
            clickTrackerUrl.searchParams.set(key, value);
          }
        });   
        fetch(clickTrackerUrl.toString(), {
          method: 'GET',
          headers: {
            'accept': 'application/json'
          }
        })
          .then(() => {
            console.log('OSMOS banner click tracker fired successfully 🚀', clickTrackerUrl.toString());
          })
          .catch(err => {
            console.log('OSMOS banner click tracker failed', err);
          });
      }
      return;
    };
    //   window.location.href = "/s/footwear-4063-31521?query=:relevance";
    const ccbKey = campaignId.toString() + bannerName.toString();
    const ccb = UTILS.getCCB(ccbKey);
    localStorage.setItem('jioadsBannerName', bannerName);
    localStorage.setItem('jioadsCmpId', campaignId);
    sessionStorage.setItem('jioads-cid', data.cid.replaceAll('[ccb]', ccb));
    localStorage.setItem('plp_page_title', freeTextSearch);
    localStorage.setItem('bannerName', bannerName);
    localStorage.setItem('campaignId', campaignId);
    const name = `jioads - ${bannerName}`;
    gtmPromotionClick(campaignId, name, dimension, adPos - 1);
    // gtmPromotionImpressions(inViewPort);

    const clktracer = data.clktrackers[0]
      .replaceAll('[trq]', Date.now())
      .replaceAll('[ccb]', ccb);
    fetch(clktracer)
      .then(res => {
        console.log('Banner click impression fired successfully url 🚀', data);
      })
      .catch(err => {
        console.log(err);
      });
  };
  const getClickUrl = () => {

    try {
      const clickURL = new URL(data.ctafb.trim());
      clickURL.searchParams.set('ref', 'banner');
      return window.location.hostname === 'localhost'
        ? clickURL.pathname + clickURL.search
        : clickURL.href;
    } catch (error) {
      return '';
    }
  };

  return (
    <div
      className="item rilrtl-products-list__item item"
      role="row"
      style={
        dimension === bannerAdViewType.list
          ? {
              ...style,
              background: currentStore === FLEEK_STORE ? '#060C10' : 'white',
              padding: '0'
            }
          : { ...style, background: currentStore === FLEEK_STORE ? '#060C10' : 'white' }
      }
    >
      {data && (
        <div role="gridcell" style={{ width: '100%', height: '100%' }}>
          <a
            onClick={() => fireClickImpression(data?.cmpid, data?.title, data?.desc, data?.sltId)}
            href={getClickUrl()}
            className="rilrtl-products-list__link"
            id={`jioAdsContainer ${data?.cmpid}`}
          >
            <div
              className="imgHolder"
              style={{
                height: '100%',
                padding: '0',
                borderRadius: dimension === bannerAdViewType.grid ? '8px' : '0px'
              }}
            >
              <img
                ref={bannerImageElRef}
                loading="lazy"
                width="100%"
                height="100%"
                src={data.customimage[0][dimension]}
                alt="Banner Ads"
              />
              {showAdTag ? <div className="adDisplay">AD</div> : null}
            </div>
          </a>
        </div>
      )}
    </div>
  );
}

/**
 *
 * @param {Array<Array>} grid - 2d Product Grid
 * @param {number} start - Start Position for the ads
 * @param {number} end - End Position for the ads
 * @param {number} freq - Frequency count of the ads
 * @param {number} adCount - Total number of ads
 * @param {number} gridColumns - Number of grid columns
 * @returns Grid with ads
 */
export function getUpdatedGridWithJioAds(grid, start, end, freq, adCount, gridColumns) {
  let total = grid.length * 2;
  const gridItems = grid.reduce((acc, group) => acc + group.length, 0);
  let output = [];
  let gridUsedIndex = 0;
  let i = 0;
  let curr = 0;
  let adIndex = 0;

  if (gridColumns === 1) {
    return grid;
  } else {
    while (gridUsedIndex < gridItems) {
      output[i] = [];
      for (let j = 0; j < 2; j++) {
        // curr > gridStart
        // grid used index represent the product count that have been appeared
        if (curr >= start && curr <= end && (curr - start) % freq === 0 && adIndex < adCount) {
          output[i].push(`ad-${adIndex}`);
          adIndex++;
        } else {
          let r = Math.floor(gridUsedIndex / 2);
          let c = gridUsedIndex % 2;
          output[i].push(grid[r] ? grid[r][c] : 'ad');
          gridUsedIndex++;
        }
        curr++;
      }
      i++;
    }
  }

  return output;
}
